module.exports = __webpack_public_path__ + "static/media/map-zoom-plus-brand-refresh.8ee20e19.svg";